export default __webpack_public_path__ + "static/media/Scourge.66702b45.jpg";